import classNames from "classnames";
import { Fragment, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import { AccountService } from "../service/AccountService";
import { TenantSettingService } from "./he-thong/tham-so-he-thong/TenantSettingService";

import { AppBreadCrumb } from "./AppBreadCrumb";
import { AppTopbar } from "./AppTopbar";

import Admin from "./admin";
import BaoCao from "./bao-cao";
import Dashboard from "./components/Dashboard";
import Category from "./danh-muc";
import System from "./he-thong";
import Invoice from "./hoa-don";
import LichSuTruyenNhan from "./lich-su-truyen-nhan";
import Publish from "./phat-hanh";
import XuLySaiSot from "./xu-ly-sai-sot";

import {
  ApplicationConfigurationService,
  storeApplicationLocalization,
} from "../service/ApplicationConfigurationService";
import {
  ERROR,
  getCurrentJob,
  getDetailJobById,
  IN_PROGRESS,
  SUCCESS,
} from "../service/ExportService";
import { AppStorage } from "../service/UserStorage";
import { FormatDisplay } from "../shared/format";
import Config from "./cau-hinh";
import { DialogExport } from "./components/ExportDialog";
import { DialogExportContext } from "./context/DialogExportContext";
import cookie from "cookiejs";

export default function App() {
  const [layoutColorMode, setLayoutColorMode] = useState("light");

  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [visibleDownloadModal, setVisibleDownloadModal] =
    useState<boolean>(false);
  const [status, setStatus] = useState<"success" | "error" | "doing">("success");
  const [minimize, setMinimize] = useState<boolean>(false);
  const [numberRecord, setNumberRecord] = useState<number>(1000);
  const [jobDetail, setJobDetail] = useState(null);

  const JOBID_RUNNING = localStorage.getItem("jobIdRunning");

  const TENNANT_ID = localStorage.getItem("iam-m-invoice-react.v1.0.0_tenant");

  const accessToken = cookie.get("access_token_report");

  const getListJob = async () => {
    if (!accessToken) return;
    const res = await getCurrentJob();
    const _res = res.filter((item: any) => item.status === IN_PROGRESS);
    if (_res.length > 0) {
      localStorage.setItem("jobIdRunning", res[0]?.jobId!);
    }
    return res;
  };

  const getDetailJobRunning = async (id: string) => {
    const res = await getDetailJobById(id);
    setJobDetail(res);
    const isExpired = res.expiredTime && new Date(res.expiredTime) < new Date();
    // if (isExpired) {
    //   setStatus("error");
    //   setVisibleDownloadModal(true);
    // }    
    if (res.status === IN_PROGRESS && isExpired) {
      setStatus("error");
      setVisibleDownloadModal(true);
      return;
    }

    if (res.status === IN_PROGRESS) {
      setStatus("doing");
      setVisibleDownloadModal(true);
      setTimeout(() => {
        getDetailJobRunning(id);
      }, 3000);
    }

    if (res.status === SUCCESS) {
      setStatus("success");
      setVisibleDownloadModal(true);
    }
    if (res.status === ERROR) {
      setStatus("error");
      setVisibleDownloadModal(true);
    }
  };

  useEffect(() => {
    getListJob().then((res) => {
      if (res && res.length > 0) {
        getDetailJobRunning(JOBID_RUNNING);
      }
    });
  }, []);

  useEffect(() => {
    if (!AppStorage.get("tenant")) {
      window.location.hash = "/login";
    } else {
      const init = [
        TenantSettingService.getList({
          key: TenantSettingService.key.DINH_DANG_TIEN_TE,
        }).then(({ items }) => {
          if (items.length) {
            try {
              const separator = items[0].description
                .split("VND l� [")[1]
                .substring(0, 1);
              switch (separator) {
                case ".":
                  FormatDisplay.locales = "vi-VN";
                  break;
                case ",":
                  FormatDisplay.locales = "en-US";
                  break;
              }
            } catch (e) {
              console.log("DINH_DANG_TIEN_TE khong hop le");
            }
          }
        }),
        FormatDisplay.loadCurrencies(),
      ];
      Promise.all(init).then(() => {
        AccountService.getMyProfile()
          .then((user) => {
            if (user?.userName) {
              setUser(user);
              ApplicationConfigurationService.get().then((res) => {
                storeApplicationLocalization(res);
                let permissions = Object.keys(res.auth.grantedPolicies);
                setPermissions(permissions);
                AppStorage.set("pk", JSON.stringify(permissions));
              });
            } else {
              window.location.hash = "/login";
            }
          })
          .catch(() => {
            window.location.hash = "/login";
          });
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode);
  };

  const wrapperClass = classNames("layout-wrapper layout-overlay", {
    "layout-theme-light": layoutColorMode === "light",
  });

  return (
    <DialogExportContext.Provider
      value={{
        visible: visibleDownloadModal,
        setVisible: setVisibleDownloadModal,
        status,
        numberRecord,
        setNumberRecord,
        onSubmit: () => { },
        setStatus,
        jobIdRunning: "",
        jobDetail,
        setJobDetail,
        minimize,
        setMinimize,
      }}
    >
      <div className={wrapperClass}>
        {user && (
          <Fragment>
            <AppTopbar
              layoutColorMode={layoutColorMode}
              onColorModeChange={onColorModeChange}
              user={user}
              permissions={permissions}
            />
            <AppBreadCrumb />
            <DialogExport
              visible={visibleDownloadModal}
              setVisible={setVisibleDownloadModal}
              status={status}
              numberRecord={numberRecord}
              onSubmit={() => { }}
            />
            <></>
            <div className="layout-main-container">
              <div className="layout-main">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="admin/*" element={<Admin />} />
                  <Route path="danh-muc/*" element={<Category />} />
                  <Route path="he-thong/*" element={<System />} />
                  <Route path="hoa-don/*" element={<Invoice />} />
                  <Route path="phat-hanh/*" element={<Publish />} />
                  <Route
                    path="lich-su-truyen-nhan/*"
                    element={<LichSuTruyenNhan />}
                  />
                  <Route path="xu-ly-sai-sot/*" element={<XuLySaiSot />} />
                  <Route path="bao-cao/*" element={<BaoCao />} />
                  <Route path="cau-hinh/*" element={<Config />} />
                </Routes>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </DialogExportContext.Provider>
  );
}
